import { useState, type Dispatch, type SetStateAction } from 'react'

/**
 * State that starts over whenever `scope` changes, for UI state that belongs to
 * one search (how far a section is revealed, which windows a list asked for).
 * It resets during render, React's "adjusting state when a prop changes", so
 * nothing ever renders one scope's value under another.
 */
export function useScopedState<T>(scope: string, initial: T): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState(initial)
  const [valueScope, setValueScope] = useState(scope)
  if (valueScope !== scope) {
    setValueScope(scope)
    setValue(initial)
    return [initial, setValue]
  }
  return [value, setValue]
}
